export default __webpack_public_path__ + "static/media/byvaapenet.3c7ef402.svg";